import Treeize from './treeize';

const surveyT = new Treeize();
const testData = [
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47933,
    'questions:SurveyQuestionName': '2018 Vote Enthusiasm',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'In November there will be an election for congress and other important offices. How excited are you to vote in this election?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198575,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Very Excited',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47933,
    'questions:SurveyQuestionName': '2018 Vote Enthusiasm',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'In November there will be an election for congress and other important offices. How excited are you to vote in this election?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198576,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Somewhat Excited',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47933,
    'questions:SurveyQuestionName': '2018 Vote Enthusiasm',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'In November there will be an election for congress and other important offices. How excited are you to vote in this election?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198582,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Not Excited',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47933,
    'questions:SurveyQuestionName': '2018 Vote Enthusiasm',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'In November there will be an election for congress and other important offices. How excited are you to vote in this election?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198583,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Unsure',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47933,
    'questions:SurveyQuestionName': '2018 Vote Enthusiasm',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'In November there will be an election for congress and other important offices. How excited are you to vote in this election?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198611,
    'questions:answers:digit': '5',
    'questions:answers:value': 'Will Not Vote',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'BYE',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47934,
    'questions:SurveyQuestionName': '2018 Vote Party',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'If the election for US Congress were held today, would you vote for the Republican candidate or the Democratic candidate?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198577,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Republican',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=4',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47934,
    'questions:SurveyQuestionName': '2018 Vote Party',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'If the election for US Congress were held today, would you vote for the Republican candidate or the Democratic candidate?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198578,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Democratic',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=4',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47934,
    'questions:SurveyQuestionName': '2018 Vote Party',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'If the election for US Congress were held today, would you vote for the Republican candidate or the Democratic candidate?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198579,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Undecided',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=3',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47935,
    'questions:SurveyQuestionName': '2018 Vote Party - Undecided Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'If you had to decide, which way would you lean?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198584,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Lean Republican',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47935,
    'questions:SurveyQuestionName': '2018 Vote Party - Undecided Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'If you had to decide, which way would you lean?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198585,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Lean Democratic',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47935,
    'questions:SurveyQuestionName': '2018 Vote Party - Undecided Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'If you had to decide, which way would you lean?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198586,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Totally Undecided',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47936,
    'questions:SurveyQuestionName': '2018 Pres Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of the job President Donald Trump is doing?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198587,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Approve',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47936,
    'questions:SurveyQuestionName': '2018 Pres Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of the job President Donald Trump is doing?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198588,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Disapprove',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47936,
    'questions:SurveyQuestionName': '2018 Pres Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of the job President Donald Trump is doing?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198589,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Unsure',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47937,
    'questions:SurveyQuestionName': 'Party Self-Id',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Now, do you think of yourself as a Republican, a Democrat or an Independent voter?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198590,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Republican',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=7',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47937,
    'questions:SurveyQuestionName': 'Party Self-Id',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Now, do you think of yourself as a Republican, a Democrat or an Independent voter?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198591,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Democrat',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=7',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47937,
    'questions:SurveyQuestionName': 'Party Self-Id',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Now, do you think of yourself as a Republican, a Democrat or an Independent voter?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198592,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Independent',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47938,
    'questions:SurveyQuestionName': 'Party Self-Id - Ind Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Would you say you generally lean Republican, lean Democrat, or are you purely an Independent?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198593,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Lean Republican',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47938,
    'questions:SurveyQuestionName': 'Party Self-Id - Ind Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Would you say you generally lean Republican, lean Democrat, or are you purely an Independent?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198594,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Lean Democratic',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47938,
    'questions:SurveyQuestionName': 'Party Self-Id - Ind Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Would you say you generally lean Republican, lean Democrat, or are you purely an Independent?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198595,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Purely Independent',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47939,
    'questions:SurveyQuestionName': 'Ethnicity',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Just to make sure we have a representative sample, please select the ethnic or racial group with which you most closely identify.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198596,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Asian',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47939,
    'questions:SurveyQuestionName': 'Ethnicity',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Just to make sure we have a representative sample, please select the ethnic or racial group with which you most closely identify.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198597,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Black',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47939,
    'questions:SurveyQuestionName': 'Ethnicity',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Just to make sure we have a representative sample, please select the ethnic or racial group with which you most closely identify.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198598,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Latinx',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47939,
    'questions:SurveyQuestionName': 'Ethnicity',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Just to make sure we have a representative sample, please select the ethnic or racial group with which you most closely identify.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198599,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Native American',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47939,
    'questions:SurveyQuestionName': 'Ethnicity',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Just to make sure we have a representative sample, please select the ethnic or racial group with which you most closely identify.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198600,
    'questions:answers:digit': '5',
    'questions:answers:value': 'White',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47939,
    'questions:SurveyQuestionName': 'Ethnicity',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Just to make sure we have a representative sample, please select the ethnic or racial group with which you most closely identify.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198601,
    'questions:answers:digit': '6',
    'questions:answers:value': 'Other',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47940,
    'questions:SurveyQuestionName': 'Religious Practice',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'About how often do you attend religious services?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198602,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Weekly',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47940,
    'questions:SurveyQuestionName': 'Religious Practice',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'About how often do you attend religious services?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198603,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Monthly',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47940,
    'questions:SurveyQuestionName': 'Religious Practice',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'About how often do you attend religious services?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198604,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Occasionally / Holidays',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47940,
    'questions:SurveyQuestionName': 'Religious Practice',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': '-1',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': '-1',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'About how often do you attend religious services?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198605,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Hardly Ever / Never',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47941,
    'questions:SurveyQuestionName': 'Education Level',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Finally, what is the highest level of schooling you have completed?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198606,
    'questions:answers:digit': '1',
    'questions:answers:value': 'High School ',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47941,
    'questions:SurveyQuestionName': 'Education Level',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Finally, what is the highest level of schooling you have completed?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198607,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Some College',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47941,
    'questions:SurveyQuestionName': 'Education Level',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Finally, what is the highest level of schooling you have completed?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198608,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Associates Degree',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47941,
    'questions:SurveyQuestionName': 'Education Level',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Finally, what is the highest level of schooling you have completed?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198609,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Bachelors Degree',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 22175,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this brief survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'This is not used',
    'questions:surveyQuestionId*': 47941,
    'questions:SurveyQuestionName': 'Education Level',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Finally, what is the highest level of schooling you have completed?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 198610,
    'questions:answers:digit': '5',
    'questions:answers:value': 'Postgraduate Degree',
    'questions:answers:answerValue': '',
    'questions:answers:action': '-1',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
];

const survey = { questions: surveyT.grow(testData).getData()[0].questions };
survey.intro = testData[0].intro;
survey.goal = testData[0].goal;
survey.endMessage = testData[0].endMessage;
export default survey;



// WEBPACK FOOTER //
// ./src/research/treeizeData.js